module.exports = __webpack_public_path__ + "static/preakness-2f70096e4f05faee9ed765353d1a564b.png";